import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureConfigService from 'garaje/services/feature-config';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

export default class LandingPageRoute extends Route {
  @service declare state: StateService;
  @service declare router: RouterService;
  @service declare featureConfig: FeatureConfigService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare abilities: AbilitiesService;

  titleToken = 'Rooms';
  beforeModel(): void {
    if (this.featureConfig.isEnabled('rooms.accessRoomsTab')) {
      void this.router.transitionTo('roomba.list');
    }

    if (this.abilities.can('use generic resource')) {
      void this.router.transitionTo('resources.resource-type.index', 3);
    }
  }
}
